const inp = "w-full mt-1 px-3 py-2 rounded-lg border border-slate-300 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500";
const TRIP = { si: { es: "Sí", fr: "Oui" }, no: { es: "No", fr: "Non" }, na: { es: "No aplica", fr: "Sans objet" }, nose: { es: "No sabe", fr: "Ne sait pas" } };

export function visible(field, values) {
  const c = field.cond;
  if (!c) return true;
  const v = values[c.k];
  if (c.not_empty) return Array.isArray(v) ? v.length > 0 : !!(v && String(v).trim());
  if (c.eq) return v === c.eq;
  if (c.in) return c.in.includes(v);
  return true;
}

function Primitivo({ field, value, onChange, idioma }) {
  const L = (o) => (idioma === "fr" ? o.fr : o.es) || o.es;
  const t = field.t;
  const tid = `campo-${field.k}`;
  if (t === "textarea")
    return <textarea data-testid={tid} rows={2} value={value || ""} onChange={(e) => onChange(e.target.value)} className={inp} />;
  if (t === "number")
    return <input data-testid={tid} type="number" value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={inp} />;
  if (t === "yesno" || t === "triple") {
    const opts = ["si", "no", "na", "nose"];
    return (
      <div className="flex gap-1.5 mt-1">
        {opts.map((o) => (
          <button key={o} type="button" data-testid={`${tid}-${o}`} onClick={() => onChange(value === o ? "" : o)}
            className={`h-8 px-3 rounded-lg text-sm border transition-colors ${value === o ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-50"}`}>
            {L(TRIP[o])}
          </button>
        ))}
      </div>
    );
  }
  if (t === "checks") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (k) => onChange(arr.includes(k) ? arr.filter((x) => x !== k) : [...arr, k]);
    return (
      <div className="flex flex-wrap gap-1.5 mt-1">
        {(field.opts || []).map((o) => (
          <button key={o.k} type="button" data-testid={`${tid}-${o.k}`} onClick={() => toggle(o.k)}
            className={`h-8 px-3 rounded-full text-sm border transition-colors ${arr.includes(o.k) ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-50"}`}>
            {L(o)}
          </button>
        ))}
      </div>
    );
  }
  if (t === "select") {
    return (
      <div className="flex flex-wrap gap-1.5 mt-1">
        {(field.opts || []).map((o) => (
          <button key={o.k} type="button" data-testid={`${tid}-${o.k}`} onClick={() => onChange(value === o.k ? "" : o.k)}
            className={`h-8 px-3 rounded-lg text-sm border transition-colors ${value === o.k ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-50"}`}>
            {L(o)}
          </button>
        ))}
      </div>
    );
  }
  return <input data-testid={tid} value={value || ""} onChange={(e) => onChange(e.target.value)} className={inp} />;
}

export function Campo({ field, value, onChange, idioma }) {
  const L = (o) => (idioma === "fr" ? o.fr : o.es) || o.es;
  if (field.t !== "repeat") return <Primitivo field={field} value={value} onChange={onChange} idioma={idioma} />;

  const rows = Array.isArray(value) ? value : [];
  const setRow = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  const add = () => onChange([...rows, {}]);
  const del = (i) => onChange(rows.filter((_, idx) => idx !== i));
  const tid = `campo-${field.k}`;
  return (
    <div className="space-y-2 mt-1">
      {rows.map((row, i) => (
        <div key={i} data-testid={`${tid}-row-${i}`} className="border border-slate-200 rounded-lg p-2.5 bg-slate-50/50">
          <div className="flex justify-between items-center mb-1">
            <span className="text-[11px] font-semibold text-slate-400">#{i + 1}</span>
            <button type="button" data-testid={`${tid}-del-${i}`} onClick={() => del(i)} className="text-red-600 text-xs font-medium">✕</button>
          </div>
          <div className="grid md:grid-cols-2 gap-2">
            {(field.sub || []).map((sub) => (
              <div key={sub.k}>
                <span className="text-[11px] text-slate-500">{L(sub)}</span>
                <Primitivo field={sub} value={row[sub.k]} onChange={(v) => setRow(i, sub.k, v)} idioma={idioma} />
              </div>
            ))}
          </div>
        </div>
      ))}
      <button type="button" data-testid={`${tid}-add`} onClick={add} className="text-sm text-blue-700 font-medium hover:text-blue-800">
        + {field["add_" + (idioma === "fr" ? "fr" : "es")] || (idioma === "fr" ? "Ajouter" : "Añadir")}
      </button>
    </div>
  );
}
